import { useActiveProperty } from '@go-client/context/ActivePropertyContext';
import { usePropertyInfo } from '@go-client/context/PropertyInfoContext';
import { safeIdCompare } from '@go-shared/lib/utils';
import { Template } from '@go-shared/types/template';
import React, { useEffect } from 'react';
import {
  BubbleButton,
  BubbleFormGroup,
  BubbleInput,
  BubbleOverlay,
  BubbleSelect,
} from '../BubbleUI';
import { FormGenericContainer } from '../FormGenericContainer';
import { TransferForm } from './TemplateTransferForm';
import TmplTnsfStatusFooter from './TmplTnsfStatusFooter';

interface TmplTransferPropPageProps {
  transferForm: TransferForm;
  template: Template;
  isBusy: boolean;
  changeTransferForm: <T extends keyof TransferForm>(key: T, val: TransferForm[T]) => void;
  onGoBack?: () => void;
  onGoNext?: () => void;
  onClose?: () => void;
}

export function TmplTransferPropPage(props: TmplTransferPropPageProps) {
  const { allProperties } = usePropertyInfo();
  const { activeProperty } = useActiveProperty();

  useEffect(() => {
    if (!props.transferForm.source && activeProperty) {
      props.changeTransferForm('source', activeProperty);
    }
  }, [activeProperty]);

  const nextDisabled = !props.transferForm.target;

  return (
    <div className="tflf-2">
      <FormGenericContainer
        footerClassName="flex-wrap"
        footer={() => (
          <>
            <TmplTnsfStatusFooter {...props} className="text-slate-dark mr-auto" />
            <BubbleOverlay loading={props.isBusy}>
              <BubbleButton variant="navy" onClick={props.onGoNext} disabled={nextDisabled}>
                Next: Confirm Events
              </BubbleButton>
            </BubbleOverlay>
          </>
        )}
      >
        <div className="flex items-start mb-5">
          <div>
            <h1 className="text-lg text-slate-dark font-semibold">Transfer Template</h1>
            <h2 className="text-2xl text-navy">1. Select Target</h2>
          </div>
          <BubbleButton
            disabled={props.isBusy}
            onClick={props.onClose}
            className="ml-auto"
            variant="navy"
            inverse
            icon="xmark-large"
            iconSize="xl"
          />
        </div>
        <div className="grid grid-cols-1 gap-4 relative">
          <BubbleFormGroup label="Target Property" asterisk>
            <BubbleSelect
              block
              allowUndefined
              value={props.transferForm.target}
              onValue={val => props.changeTransferForm('target', val)}
              options={allProperties.filter(p => !safeIdCompare(p._id, activeProperty._id))}
              labelExtractor={v => v.name}
            />
          </BubbleFormGroup>
          <BubbleFormGroup label="Rename On Transfer" asterisk>
            <BubbleInput
              block
              type="text"
              placeholder={props.template.name}
              value={props.transferForm.templateName}
              onValue={val => props.changeTransferForm('templateName', val)}
            />
          </BubbleFormGroup>
        </div>
      </FormGenericContainer>
    </div>
  );
}
